import { render } from "./aboutCTA.vue?vue&type=template&id=3701b035&scoped=true"
import script from "./aboutCTA.vue?vue&type=script&lang=js"
export * from "./aboutCTA.vue?vue&type=script&lang=js"

import "./aboutCTA.vue?vue&type=style&index=0&id=3701b035&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3701b035"]])

export default __exports__